import { useEffect } from 'react';
import classNames from 'classnames';
import Switch from 'react-bootstrap-switch';
import { useForm } from 'react-final-form';
import { useFieldValue } from 'hooks/useFormHelpers';
import { PaymentOptionHeaderInfo } from './HeaderInfo';
import { RecExpandedPaymentRow } from './DragNDropRecExpanded';
import { OfflinePaymentDetails } from './OfflinePaymentDetails';

type PaymentMethodRowProps = {
  row: RecExpandedPaymentRow;
  activeRowId: string | null;
  handleRowClick: (rowId: string) => void;
  isMobile: boolean;
  withDetails: boolean;
  paymentSwitchDisabled?: (enabledFieldName: string) => boolean;
};

export const PaymentMethodRow = ({
  row,
  activeRowId,
  handleRowClick,
  isMobile,
  withDetails,
  paymentSwitchDisabled,
}: PaymentMethodRowProps) => {
  const form = useForm();
  const switchFieldName = `${row.enabledFieldName}_enabled`;
  const isActive: boolean = useFieldValue(switchFieldName);
  const switchDisabled = paymentSwitchDisabled?.(row.enabledFieldName) ?? false;

  useEffect(() => {
    if (!isActive && activeRowId === row.value) {
      handleRowClick(row.value);
    }
  }, [isActive, activeRowId, handleRowClick, row.value]);

  return (
    <>
      <tr
        className={classNames({
          active: activeRowId === row.value,
          'expanded-content': activeRowId === row.value,
        })}
      >
        <td
          className={classNames('rec-header-info rec', {
            expanded: activeRowId === row.value,
            mobile: isMobile,
            active: isActive,
          })}
        >
          <PaymentOptionHeaderInfo label={row.label} imageUrl={row.imageUrl} />
          {!isMobile && withDetails && (
            <div className="flex-wrap-nowrap">
              <button
                type="button"
                className={classNames('oath-bodysmall link-text show-hide-text', {
                  active: activeRowId === row.value,
                  disabled: !isActive,
                })}
                disabled={!isActive}
                onClick={e => {
                  e.stopPropagation();
                  if (!isActive) return;
                  handleRowClick(row.value);
                }}
              >
                {activeRowId === row.value ? 'Close Details' : 'Add Details'}
              </button>
            </div>
          )}
        </td>
        <td className="delete-td rec payment-switch-td">
          <Switch
            value={isActive}
            onColor="success"
            onText="ON"
            offColor="success"
            offText="OFF"
            handleWidth={500}
            onChange={(e: any) => form.change(switchFieldName, e.state.value)}
            disabled={switchDisabled}
          />
        </td>
      </tr>
      {activeRowId === row.value ? (
        <tr>
          <td className="rec-details-info expanded-details rec">
            <OfflinePaymentDetails selectedPaymentMethod={row} handleRowClick={handleRowClick} />
          </td>
          <td />
        </tr>
      ) : isMobile && withDetails ? (
        <tr>
          <td colSpan={1} className="add-details-mobile">
            <button
              type="button"
              className={classNames('oath-bodysmall link-text gray', {
                disabled: !isActive,
              })}
              disabled={!isActive}
              onClick={e => {
                e.stopPropagation();
                if (!isActive) return;
                handleRowClick(row.value);
              }}
            >
              Add Details
            </button>
          </td>
        </tr>
      ) : null}
    </>
  );
};
